export const SET_RIDER_DATA = "SET_RIDER_DATA";
export const SET_RIDER_PAGINATION = "SET_RIDER_PAGINATION";
export const SET_RIDER_DETAIL_DATA = "SET_RIDER_DETAIL_DATA";
export const RESET_RIDER_REDUCER = "RESET_RIDER_REDUCER";
